import { useQuery } from '@tanstack/react-query';

import { getProjectDetails } from './projects';

export const PROJECT_DETAILS_KEY = 'ProjectDetails';

export const useGetProjectDetails = (projectId: string | null | undefined) => {
  return useQuery({
    queryKey: [PROJECT_DETAILS_KEY, projectId],
    queryFn: () => getProjectDetails(projectId!),
    enabled: !!projectId,
  });
};
